import { atom } from "jotai";
import { ActionSheetInstance } from "./AppActionSheets";

export const actionSheetsAtom = atom<ActionSheetInstance<any>[]>([]);
